import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`

    .image {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 1em;

        img {
            width: 100%;
            height: 20vh;
            object-fit: contain;
            border-radius: .5em;
        }
    }

    .title {
        color: #b29051;
        font-size: 2em;
        font-weight: 700;
        margin: 0.25em;
    }

    @media all and (max-width: ${variables.mobileL}) {
        position: relative;
        width: 100%;
        border-radius: 1em;
        background-color: white;
        box-shadow: 0 .6em 1em #484a521a;
        justify-content: center;
    }
`;
